import React,{useContext} from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ClosedIcon = (props) => {
  const { themeName, getThemeColor, getThemeColorForTab} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8335 2.25H3.8335C3.0085 2.25 2.3335 2.925 2.3335 3.75V14.25C2.3335 15.075 3.0085 15.75 3.8335 15.75H15.8335C16.6585 15.75 17.3335 15.075 17.3335 14.25V3.75C17.3335 2.925 16.6585 2.25 15.8335 2.25ZM15.8335 14.25H3.8335V3.75H15.8335V14.25Z"
        // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.391 7.815L14.326 6.75L11.9485 9.1275L10.891 8.0625L9.8335 9.12L11.9485 11.25L15.391 7.815Z"
        // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
      <path d="M8.3335 5.25H4.5835V6.75H8.3335V5.25Z"  fill={getThemeColorForTab(props.active)} />
      <path d="M8.3335 8.25H4.5835V9.75H8.3335V8.25Z"  fill={getThemeColorForTab(props.active)} />
      <path d="M8.3335 11.25H4.5835V12.75H8.3335V11.25Z"  fill={getThemeColorForTab(props.active)} />
    </svg>
  );
};

export default ClosedIcon;
